/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import { indicatorsList } from "../../funcs/indicatorsList.js";
import { formatResult, ToolDefinition } from "../tools.js";

export const tool$indicatorsList: ToolDefinition = {
  name: "indicators-list",
  description: `List available indicators

Returns the list of all available market indicators that
        Hedgewise tracks or produces.`,
  tool: async (client, ctx) => {
    const [result, apiCall] = await indicatorsList(
      client,
      { fetchOptions: { signal: ctx.signal } },
    ).$inspect();

    if (!result.ok) {
      return {
        content: [{ type: "text", text: result.error.message }],
        isError: true,
      };
    }

    const value = result.value;

    return formatResult(value, apiCall);
  },
};
